import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * @FilePath: \kitchen-online-web\src\components\OptionsCard\optionsCard.tsx
 * @Author: yehao Gao
 * @Date: 2021-12-20 17:39:15
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-06-10 16:30:06
 */
import propTypes from 'prop-types';
import useDebounce from '@/hooks/commonHooks/useDebounce';
import style from './optionsCard.module.scss';
function OptionsCard(props) {
    const { type, itemClick, visible, listWall, listFloor, wallId, floorId, } = props;
    const onTouchStart = useDebounce((id) => {
        itemClick(type, id);
    });
    return (_jsxs("div", Object.assign({ className: `${style.wrap} ${type ? style.wall : style.ground}` }, { children: [_jsx("div", Object.assign({ style: { display: visible ? 'flex' : 'none' }, className: style.container }, { children: type ? (listWall && (listWall === null || listWall === void 0 ? void 0 : listWall.map((item) => (_jsx("div", Object.assign({ className: `${style.item} ${wallId === item.id ? style.active : ''}`, "aria-hidden": true, onTouchStart: (e) => { onTouchStart(item.id); e.stopPropagation(); } }, { children: _jsx("img", { alt: "", src: item === null || item === void 0 ? void 0 : item.url }, void 0) }), void 0))))) : (listFloor && (listFloor === null || listFloor === void 0 ? void 0 : listFloor.map((item) => (_jsx("div", Object.assign({ className: `${style.item} ${floorId === item.id ? style.active : ''}`, "aria-hidden": true, onTouchStart: (e) => { onTouchStart(item.id); e.stopPropagation(); } }, { children: _jsx("img", { alt: "", src: item === null || item === void 0 ? void 0 : item.url }, void 0) }), item.id))))) }), void 0),
            _jsx("div", { style: { display: visible ? 'block' : 'none' }, className: style['arrow-right'] }, void 0)] }), void 0));
}
OptionsCard.propTypes = {
    type: propTypes.number,
    itemClick: propTypes.func.isRequired,
    visible: propTypes.bool.isRequired,
    listWall: propTypes.oneOfType([propTypes.array]).isRequired,
    listFloor: propTypes.oneOfType([propTypes.array]).isRequired,
    wallId: propTypes.number.isRequired,
    floorId: propTypes.number.isRequired,
};
OptionsCard.defaultProps = {
    type: 0,
};
export default OptionsCard;
